export const DESELECT_AFTER_CLOSE_DELAY = 300

export type EpgSidebarProgramInfo = {
  actors: string[]
  categories: string[]
  channelName: string
  description?: string
  directors: string[]
  episode?: string
  icon?: string
  logoUrl?: string
  subtitle?: string
  date?: string
  rating?: string
  title?: string
  actualStartMs: number
  actualStopMs: number
}

export type EpgSidebarProgramLocalizedInfo = EpgSidebarProgramInfo & {
  isLive: boolean
  labels: string[]
}

export type EpgSidebarInfo = {
  actors: string[]
  categories: string[]
  channelName: string
  description?: string
  directors: string[]
  episode?: string
  icon?: string
  isLive: boolean
  isLoading?: boolean // ???
  labels: string[]
  logoUrl?: string
  subtitle?: string
  tags: string[]
  title?: string
}

export type EpgSidebarLocalizedInfo = EpgSidebarInfo & {
  titleDirectors: string
  titleStars: string
  titleUpcoming: string
}
